// extracted by mini-css-extract-plugin
export default {"banner":"bl0_psUChA6c8WYuFUcd","text":"FgXdf0Od_FwAu5mDH_IK","link":"aDk8MkQWBZa9n7n20zb1"};